import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { IEmailLogs } from '../../../../utils/interfaces/email-log';
import { IGroupedEmailRecipients, ScheduledEmailLogRecipient } from '../../../../utils/interfaces/emailRecipient';

@Component({
  selector: 'app-email-details',
  standalone: true,
  imports: [CommonModule, MatDialogTitle, MatDialogContent, MatIconModule],
  templateUrl: './email-details.component.html',
  styleUrl: './email-details.component.scss',
})
export class EmailDetailsComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<EmailDetailsComponent>);
  readonly data = inject<{ failed: boolean; log: IEmailLogs }>(MAT_DIALOG_DATA);

  branchName = '';
  branchCode = '';
  date = '';

  listGrid: IGroupedEmailRecipients[] = [];

  ngOnInit(): void {
    this.groupEmailRecipients();
  }

  private groupEmailRecipients(): void {
    if (!this.data?.log?.scheduledEmailLogRecipientsList) {
      return;
    }

    const recipients = this.data.log.scheduledEmailLogRecipientsList;
    const groupedByBranch: { [key: string]: IGroupedEmailRecipients } = {};

    recipients.forEach(recipient => {
      const key = recipient.branchCode || 'NO_BRANCH';

      if (!groupedByBranch[key]) {
        groupedByBranch[key] = {
          frequency: this.data.log.frequency,
          sendDate: this.data.log.sendDate,
          branchCode: recipient.branchCode || '',
          branchName: recipient.branch || '',
          sentSuccessfullyList: [],
          failedList: [],
          total: 0
        };
      }

      if (recipient.sentSuccessfully) {
        groupedByBranch[key].sentSuccessfullyList.push(recipient);
      } else {
        groupedByBranch[key].failedList.push(recipient);
      }

      groupedByBranch[key].total++;
    });

    this.listGrid = Object.values(groupedByBranch)
      .sort((a, b) => a.branchCode.localeCompare(b.branchCode));
  }

  getTotalSuccess(): number {
    return this.listGrid.reduce((total, group) => total + group.sentSuccessfullyList.length, 0);
  }

  getTotalFailed(): number {
    return this.listGrid.reduce((total, group) => total + group.failedList.length, 0);
  }

  getTotalBranches(): number {
    return this.listGrid.length;
  }

}
